<template>
  <el-table-column
    prop="payment_date"
    sortable="custom"
    label="Határidő"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.payment_date | date }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'payment_date',
};
</script>
